module.exports = __webpack_public_path__ + "assets/Logo-f4975b.svg";